import React, { useContext } from "react";
import "./RegionConfigurator.scss";
import { I18nContext } from "../../context";
import Select from "../Select/Select";

/**
 * Region configuration form
 * @param {Object} props
 * @param {Array} props.regions Available regions
 * @param {Function} props.setRegion Save region on submit
 * @param {Function} props.onSetRegion Callback
 * @returns {React.ReactElement}
 */
function RegionConfigurator({ regions, setRegion, onSetRegion }) {
  const { locale } = useContext(I18nContext);

  const onSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.target);
    const code = data.get("region");
    const region = regions.find((region) => region.Code === code);

    setRegion(region);
    onSetRegion();
  };

  const options = regions.map((region) => ({
    value: region.Code,
    label: region.Name,
  }));

  return (
    <form className="RegionConfigurator" onSubmit={onSubmit}>
      <p className="RegionConfigurator__text">{locale.regionSubtitle}</p>
      <Select options={options} name="region" label={locale.regionLabel} />
      <button className="RegionConfigurator__submit" type="submit">
        {locale.regionButtonLabel}
      </button>
    </form>
  );
}

export default RegionConfigurator;
